export default function mockFrequencies(
  status = '',
  undersaturated = 0,
  oversaturated = 20,
  eventType = 'commercial'
) {
  let frequencies = {
    aggregates: {
      totalSubscribers: 15049,
      totalEmailSent: 63617,
      undersaturationRate: 0,
      oversaturationRate: 0,
      averageOpenRate: 0,
      averageClickRate: 0,
      averageUnsubscribeRate: 0
    },
    frequencies: [],
    updatedOn: '2019-02-26'
  };
  let frequencyArray = [];
  let object, numEmail, saturationType, subscribers;
  let rate, openRate, clickRate, unsubscribeRate;
  const min = 1;
  const max = oversaturated + 30;

  if (status !== 'no_data') {
    frequencies = {
      aggregates: {
        totalSubscribers: 15049,
        totalEmailSent: 63617,
        undersaturationRate: status === 'no_recommendation' ? 0 : 0.0903,
        oversaturationRate: status === 'no_recommendation' ? 0 : 0.7326,
        averageOpenRate: 0.1764,
        averageClickRate: 0.0517,
        averageUnsubscribeRate: 0.0118
      },
      frequencies: [],
      updatedOn: '2019-02-26'
    };
    for (let i = min; i <= max; i++) {
      numEmail = i.toString();
      if (status === 'no_recommendation' || status === 'insufficient_data') {
        saturationType = 'none';
      } else {
        if (i < undersaturated) {
          saturationType = 'under';
        } else if (i > oversaturated) {
          saturationType = 'over';
        } else {
          saturationType = 'neutral';
        }
      }

      const subCeiling = 100000;
      subscribers = Math.max(
        subCeiling - Math.floor(Math.random() * (4 * subCeiling) * (i / max)),
        1
      );
      rate = Math.random();
      openRate = rate * Math.random();
      clickRate = openRate * Math.random();
      unsubscribeRate = clickRate * Math.random();

      //contains both the v1 and v2 fields
      object = {
        numEmail,
        eventType,
        subscribers,
        rate,
        openRate,
        clickRate,
        unsubscribeRate,
        saturationType
      };
      frequencyArray.push(object);
    }
  }

  frequencies['frequencies'] = frequencyArray;

  return frequencies;
}
